import { LocationTypeGetResult, LocationTypeGetResponse } from './ribbon.types'
import { get } from 'services/axios'

export const getLocationTypes = (): Promise<LocationTypeGetResult> => {
  // https://api.ribbonhealth.com/v1/location_types
  const url = '/location_types'

  return get<LocationTypeGetResponse>(url).then(res => res.data)
}
